import { render } from "./CustomFields.vue?vue&type=template&id=5aefd13e&scoped=true"
import script from "./CustomFields.vue?vue&type=script&lang=js"
export * from "./CustomFields.vue?vue&type=script&lang=js"

import "./CustomFields.vue?vue&type=style&index=0&id=5aefd13e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5aefd13e"]])

export default __exports__